import http from '../../../../common/utils/http'
import apiUtils from '../../../../common/utils/apiUtils'
import {API_BASE_URL} from '../../../../common/utils/commonUrl'

export default {
  getMembersByPage: (pageData) => {
    return http.get(`${API_BASE_URL}/api/wxoa/member/member/getVerifiedMemberList`, {params: pageData}).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  grantOfCouponByData: (data) => {
    return http.post(`${API_BASE_URL}/api/wxoa/coupon/couponExample/addIsMainCouponExample`, data).then(
      function (result) {
        return apiUtils.getDataFormCodeResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  getCouponsInfo: (codes) => {
    return http.post(`${API_BASE_URL}/api/wxoa/coupon/couponExample/getCouponDefinitionByCode`, codes).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  getApprovalByMemberId: (data) => {
    return http.get(`${API_BASE_URL}/api/wxoa/coupon/couponExample/getCouponInstanceBuyByMemberId`, {params: data}).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  couponApproval: (data) => {
    return http.post(`${API_BASE_URL}/api/wxoa/coupon/couponExample/processIsMainCouponExample`, data).then(
      function (result) {
        return apiUtils.getDataFormCodeResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/wx-member/go-out-management/card-operation/card-operation.js